import { Box, Button, Container, Grid2 } from "@mui/material";
import { TitleButton } from "./UI/Title";
import banner from "../assets/images/bannerDownloadMinecraft.jpg";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import { DownloadMinecraftContent } from "./websiteContent";

const DownloadMinecraft = () => {
  const root = DownloadMinecraftContent;
  return (
    <Fragment>
      <img src={banner} alt="Generation AI" className="bannerImage" />
      <Container fixed>
        <div className="mainBody">
          <h1>Getting Started with Minecraft Education</h1>
        </div>
        <section>
          <TitleButton
            title={root.title.title}
            paragraph={root.title.paragraph}
          />
          <Grid2 container justifyContent={"center"} spacing={4}>
            {root.steps.map((item, index) => (
              <Grid2 size={{ xs: 12, lg: 4 }} key={index.toString()}>
                <Box className="stepsDownload">
                  <img src={item.icon} alt={item.title} />
                  <span>{item.title}</span>
                  <p>{item.paragraph}</p>
                  {item.button &&
                    item.button.map((item, index) => (
                      <Link
                        to={item.link}
                        target={item.target}
                        key={index.toString()}
                      >
                        <Button variant="outlined">
                          {item.text}
                          <ArrowForwardIcon />
                        </Button>
                      </Link>
                    ))}
                </Box>
              </Grid2>
            ))}
          </Grid2>
        </section>
      </Container>
    </Fragment>
  );
};

export default DownloadMinecraft;
